@if (initialized) {
  <div id="root-container" class="container-fluid" [ngClass]="['layout-' + application.layout]">
    <div id="outlet-container">
      <router-outlet />
    </div>
  </div>
} @else {
  <app-splash />
}
